module.exports = __webpack_public_path__ + "media/gameOn.2690fd42.mp3";